<template>
  <div class="modal topup-modal">
    <div class="overlay" @click="$parent.closeTopUpModal"></div>
    <div class="wrapper">
      <img src="../img/corners3/top-left-corner.svg" class="top-left" />
      <img src="../img/corners3/top-right-corner.svg" class="top-right" />
      <img src="../img/corners3/bottom-left-corner.svg" class="bottom-left" />
      <img src="../img/corners3/bottom-right-corner.svg" class="bottom-right" />
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img
              class="close"
              @click="$parent.closeTopUpModal"
              src="./../img/close.svg"
            />
            <div class="form-fields">
              <div class="form-fields-wrapper">
                <div class="title dark">TOP UP</div>
                <label>
                  <div class="desc dark">Enter your amount:</div>
                  <!-- <div class="title small cur">{{ currency }}</div> -->
                  <input
                    type="text"
                    @input="allowOnlyNumbers"
                    placeholder="Enter amount"
                    v-model="amount"
                  />
                </label>
                <div class="desc exchange">
                  <span>1</span>
                  <img src="../img/coin.svg" class="coin" />
                  <span>= {{ coinRate }}{{ currency }}</span>
                </div>
                <div class="desc or">or</div>
                <div class="list">
                  <label>
                    <input
                      type="radio"
                      v-model="amount"
                      value="5"
                      name="amountRadios"
                    />
                    <div class="button">5.00 {{ currency }}</div>
                  </label>
                  <label>
                    <input
                      type="radio"
                      v-model="amount"
                      value="10"
                      name="amountRadios"
                    />
                    <div class="button">10.00 {{ currency }}</div>
                  </label>
                  <label>
                    <input
                      type="radio"
                      v-model="amount"
                      value="15"
                      name="amountRadios"
                    />
                    <div class="button">15.00 {{ currency }}</div>
                  </label>
                  <label>
                    <input
                      type="radio"
                      v-model="amount"
                      value="25"
                      name="amountRadios"
                    />
                    <div class="button">25.00 {{ currency }}</div>
                  </label>
                  <label>
                    <input
                      type="radio"
                      v-model="amount"
                      value="50"
                      name="amountRadios"
                    />
                    <div class="button">50.00 {{ currency }}</div>
                  </label>
                  <label>
                    <input
                      type="radio"
                      v-model="amount"
                      value="100"
                      name="amountRadios"
                    />
                    <div class="button">100.00 {{ currency }}</div>
                  </label>
                  <label>
                    <input
                      type="radio"
                      v-model="amount"
                      value="200"
                      name="amountRadios"
                    />
                    <div class="button">200.00 {{ currency }}</div>
                  </label>
                </div>
                <button :disabled="!amount" @click="toCheckout" class="button">
                  TOP UP
                </button>
                <transition name="slide">
                  <div v-if="$parent.error" class="error-desc desc red">
                    {{ $parent.error }}
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopUpModal",
  props: ["currency", "currencyValue"],
  components: {},
  data: function () {
    return {
      amount: "",
    };
  },
  computed: {
    coinRate() {
      const rate = parseFloat(this.currencyValue) || 1;
      const settings = this.$parent.settings || {};
      const creditsRate = settings.credits_enabled ? (settings.credits_conversion_rate || 1) : 1;
      return (rate / creditsRate).toFixed(2);
    },
  },
  mounted() {},
  methods: {
    allowOnlyNumbers() {
      this.amount = this.amount.replace(/[^0-9.,]/g, "");
      const parts = this.amount.split(/[.,]/);
      const integerPart = parts[0];
      let decimalPart = parts[1];
      if (decimalPart !== undefined && decimalPart.length > 2) {
        decimalPart = decimalPart.slice(0, 2);
      }
      this.amount =
        decimalPart !== undefined
          ? `${integerPart}.${decimalPart}`
          : integerPart;
    },
    toCheckout() {
      this.$emit("setTopUpAmount", this.amount);
    },
  },
};
</script>
